import React, { useContext, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import { ECCommonErrorBlock } from '@/components/Forms/ECCommonErrorBlock';
import { ECTextField } from '@/components/Forms/ECTextField';
import { ECPhotoField } from '@/components/Forms/ECPhotoField';
import { ECCheckboxField } from '@/components/Forms/ECCheckboxField';
import Button from '@mui/material/Button';
import { ECSelectField } from '@/components/Forms/ECSelectField';
import { fieldKey } from '../../VisitorList/components/ImportXLS/import_utils';
import { MeetupContext } from '@/MeetupContext';
import Paper from '@mui/material/Paper';
import { ECQuillEditor } from '@/components/Forms/ECQuillEditor';
import { AttachmentsList } from '../../OnlineRegistration/components/AttachmentsList';
import { NewsTypes } from './NewsTable';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import { NewsType } from '@/api';

const PREFIX = 'NewsTypeForm';

const classes = {
  editor: `${PREFIX}-editor`,
  spacing: `${PREFIX}-spacing`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.editor}`]: {
    '& .ql-editor': {
      height: 200,
    },
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },

  [`& .${classes.spacing}`]: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const NewsTypeForm = props => {
  const { form, initial } = props;
  const meetupContext = useContext(MeetupContext);

  const [type, setType] = useState(NewsType.Notification);

  useEffect(() => {
    form.register('type');
    form.setValue('type', type);
  }, []);

  return (
    <Root>
      <Grid container spacing={3}>
        <RadioGroup
          aria-label='type'
          name='type'
          value={type}
          onChange={e => {
            setType(e.target.value);
            form.setValue('type', e.target.value);
          }}
        >
          {Object.keys(NewsTypes).map(t => (
            <FormControlLabel value={t} control={<Radio />} label={NewsTypes[t]} key={t} />
          ))}
        </RadioGroup>
      </Grid>
    </Root>
  );
};

export default NewsTypeForm;
